export function parseDataSave(value) {
  let dataSave = [];
  value?.forEach(parentItem => {
    if (parentItem?.children?.length > 0) {
      parentItem.children.forEach(childItem => {
        if (childItem?.ischeck) {
          dataSave.push({
            functionid: childItem.id,
            ischeck: childItem.ischeck,
            coquyenpheduyet: false
          });
        }
      });
    }
  });
  return dataSave;
}
